import React, { useState, useContext, useEffect, useRef } from 'react'
import DictionaryContext from '../../../context/dictionaryContext'
import PatientContext from '../../../context/patientContext'
import UserPrefContext from '../../../context/userPrefContext'
import AuthContext from '../../../context/authContext'
import SynkinesisListRow from './SynkinesisListRow'

function SynkinesisList(props) {

    const dictCtx = useContext(DictionaryContext)
    const visCtx = useContext(PatientContext)
    const userPrefCtx = useContext(UserPrefContext)
    const authCtx = useContext(AuthContext)
    
    const synkinesisGetAllURL = `${process.env.REACT_APP_SERVER}/api/v1/synkinesis_assessments/get_all_by_token/${visCtx.pat_token}`

    const [synkinesises, setSynkinesises] = useState([])
    const [columnMapping, setColumnMapping] = useState([['Action',null], ['Date', 'updated_at'], ['Sum of Scores', 'sum_of_scores'], ['SAQ Total Score','saq_total_score']])


    const getAllSynkinesisAssessments = async() => {
        // console.log("EFaceList - getting all efaces")
        try {
            const response = await fetch(synkinesisGetAllURL, {
                headers: {
                    'Authorization': `Bearer ${userPrefCtx.bearerToken}`,
                    auth: authCtx.authMode,
                },

            })

            if (response.status === 200) {
                const responseData = await response.json()
                // console.log("Get all Synkinesis Assessments", responseData)
                // sort them by eface_date
                setSynkinesises(responseData.sort((a,b) => new Date(a.updated_at) > new Date(b.updated_at) ? 1 : -1))
            } else {
                console.log("Failed to get all Synkinesis Assessments", response)
            }
        } catch (e) {
            console.log("Failed to get all Synkinesis Assessments", e)
        }

    }


    // useEffect(() => {
    //     // console.log("SynkinesisList - getting column mappings")
    //     // setColumnMapping(props.columnMapping)
    //     if (dictCtx.dict_table.length > 0) {
    //         let headersMapping = dictCtx.dict_table.filter(entry => entry.group_display_name_short === 'the_eface')
    //         if (headersMapping.length > 0) {

    //         }
    //         setColumnMapping(JSON.parse(headersMapping[0].column_name))
    //     }
        
    // }, [/*props.columnMapping*/ dictCtx.dict_table.length])

    useEffect(async() => {
        // console.log("EFaceList - props.updateDeleteCount", props.updateDeleteCount)
        if (userPrefCtx.bearerToken !== '') {
            getAllSynkinesisAssessments()
        }
        
    }, [userPrefCtx.bearerToken, props.updateDeleteCount])

    


    


    const onSelect = (synkinesis) => {
        props.onSelect(synkinesis)
    }

    return (
         <>
        <div>
            <table className="table table-sm table-borderless">
                <thead>
                    <tr>
                        {columnMapping.map((val, index) =>
                            <th scope="col" key={index} className='mx-4 px-10 text-left'>{val[0]}</th> 
                        )}
                    </tr>
                </thead>
                <tbody>
                    {synkinesises.map((s, index) => 
                        <SynkinesisListRow key={index} columnMapping={columnMapping} synkinesis={s} onSelect={onSelect}/>
                    )}

                </tbody>
            </table>
        </div>
        </>
    )
}

export default SynkinesisList
